<template>
    <div style="min-height: 90vh;">
        <div class="d-flex justify-content-center" style="font-size: 1.1rem; gap:5px; margin-bottom: 2rem; flex-wrap: wrap;">
            <span><span style="background: white; border: 1px solid black; padding: 5px;">Print</span> Badges for: </span>
            <span style="font-weight: bold;">{{ checkpoint ? checkpoint.name : '' }}</span>
        </div>
        <div v-if="checkins.length">
            <div  class="d-flex align-items-center mb-4">
                <el-button class="d-flex align-items-center" @click="rescan">
                    <svg style="width: 16px; height:16px;" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                    </svg>
                    <span class="ml-2">Rescan</span>
                </el-button>
            </div>
    
            <div style="display: flex; flex-direction: column; gap: 20px;">
                <!-- <div v-if="checkins.length">
                    <div style="width: max-content;" class="">
                        <label style="position: relative; display: flex; align-items: center;" v-for="(att, idx) in attendees">
                            <div class="checkbox-container m-0">
                                <input type="checkbox" v-model="ticks[idx]" @change="toggleSelectCheckins(att, ticks[idx])" :id="idx + att._id">
                                <span class="checkmark">
                                    <svg class="checkmark-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                        <path class="checkmark-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                                    </svg>
                                </span>
                            </div>
                            <p class="m-0 ml-3 d-flex align-items-center">
                                <span style="font-size: 1.1rem;">{{ att | registrationName }}</span>
                                <span style="font-weight: lighter; font-size: x-small;" class="ml-1">(Checked in)</span>
                            </p>
                        </label> 
                    </div>
                </div> -->

                <div v-if="checkins.length > 0" style="position: relative; border: 1px solid rgb(160, 160, 160); padding: 10px;" v-for="(checkin, idx) in checkins" :key="checkin._id">
                    <div style="position: absolute; top: -9px; z-index:100; left: 50px; display: flex; gap:5px;">
                        <el-tag class="border status-tag" 
                            :style="getColorForStatus(checkin.status)"
                        >
                            {{ checkin.status }}
                        </el-tag>
                        
                        <el-tag class="bg-secondary border">
                            {{ checkin.registrantIds.length }}
                        </el-tag>
                        <el-tag 
                            v-if="checkin.printed"
                            class="border status-tag" 
                            :style="getColorForStatus('printed')"
                        >
                            printed
                        </el-tag>
                    </div>
                    <div class="responsive-table">
                        <table>
                            <thead>
                                    <th style="min-width: 30px; display: flex; justify-content: left;">
                                        <label class="checkbox-container m-0">
                                            <input type="checkbox" v-model="ticks[idx]" @change="toggleSelectCheckins(checkin, ticks[idx])" :id="idx + checkin._id">
                                            <span class="checkmark">
                                                <svg class="checkmark-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                                    <path class="checkmark-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                                                </svg>
                                            </span>
                                        </label>
                                    </th>
                                    <th style="min-width: 180px;">Name</th>
                                    <th style="min-width: 150px;">Timestamp</th>
                            </thead>
                
                            <tbody>
                                <tr v-for="att in checkin.attendees">
                                    <td></td>
                                    <td>{{ att | registrationName }}</td>
                                    <td>{{ checkin.createdAt | formatTimestamp }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="p-3 d-flex align-items-center" style="font-size: 1rem; gap:20px;">
                            <div>
                                <span class="mr-2"> Code: </span>
                                <span style="font-weight: bold; font-size: 1.2rem;">{{ checkin.code }}</span>
                            </div>
                            <div>
                                <span class="mr-2">Registration: </span>
                                <span style="font-weight: bold; font-size: 1.2rem;">{{ checkin.confirmationNumber }}</span>
                            </div>
                        </div>

                        <p v-if="checkin.note" class="pl-3" style="font-size: 1rem; display: flex; gap:5px;">
                            <span class="mr-2">Note: </span>
                            <span class="quill-editor" v-html="checkin.note"></span>
                        </p>
                    </div>
                </div>
            </div>

            <el-button :loading="loading" v-if="checkins.length" style="width: 100%" class="btn btn-primary" @click="printCheckins">
                Print Badges
            </el-button>
        </div>
        <div v-else>
            <div v-if="!processingQr">
                <template v-if="checkpoint && checkpoint.kioskPrintUsingRegId">
                    <p class="d-flex justify-content-center">Search for checkins</p>
                    <div class="idinput">
                        <el-input type="text" placeholder="Registration ID or Registration Number" name="" id="" v-model="registrationId" />
                        <el-button class="proceed-btn btn btn-primary" @click="scan" :loading="loading">Search</el-button>
                    </div>
                </template>

                <p v-if="checkpoint && checkpoint.kioskPrintUsingBadge && checkpoint.kioskPrintUsingRegId" class="my-4" style="font-weight: bold;  text-align: center;">OR</p>
                
                <template v-if="checkpoint && checkpoint.kioskPrintUsingBadge">
                    <p class="d-flex justify-content-center">Scan badge to begin checkin</p>
                    <div class="badge-scanner">
                        <el-button class="scan-badge-btn" :loading="loading" @click="scannerOpen = !scannerOpen">Scan Badge</el-button>
                    </div>    
                    <el-dialog
                        v-if="scannerOpen"
                        :close-on-click-modal="false"
                        :visible.sync="scannerOpen">
                        <QrScanner @onDecode="handleDecoded" />
                        <p class="d-flex justify-content-center mt-2" style="color: gray;">Switch camera here if needed</p>
                    </el-dialog>
                </template>
            </div>
            <div class="d-flex justify-content-center py-4" v-else>
                <Loading />
            </div>
        </div>
        <p style="height: 1px; border-top: 1px solid #c6c8cc; margin-top: 50px;"></p>
        <div class="d-flex justify-content-center" style="margin-top: 30px;">
            <p style="border: 1px solid rgba(0, 0, 0, 0.3); background: white; padding: 5px 10px; width: max-content;">Not checked in yet ?  <router-link class="mx-2" :to="{ name: 'public-kiosk-checkin' }"> click here </router-link> checkin first</p>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import http from "../../http.js";
import { mapState } from 'vuex';
import QrScanner from "../../components/QrScanner.vue"
import Loading from "../Loading.vue";
import CheckinDataForm from "../../components/CheckinDataForm.vue"
export default {
    components: { 
        QrScanner, 
        Loading,
        CheckinDataForm
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            registrationId: null,
            attendees: [],
            selectedCheckins: [],
            ticks: [],
            showForms: [],
            loading: false,
            processingQr: false,
            checkpoint: null,

            // checkpointFields: [],
            // fieldDatas: [],
            // fieldsPerRegistration: {},
            // recordedCheckpointFieldData: [],
            // needsSavingFields: false,
            // fieldsToShow: [],
            // checkpointFieldIds: [],
            // errs: {},
            home: '',
            scannerOpen: false,
            checkins: [],
        }
    },
    computed: {
        ...mapState(['event', 'checkpoints', 'fields']),
    },
    methods: {
        getColorForStatus(status){
            if(status == "checked-out") return "background: #000;";
            if(status == "accepted") return "background: green;";
            if(status == "printed") return "background: #409EFF;";
            if(status == "deleted") return "background: #e70202;";

            return "background: #e7ad02;"
        },
        toggleShowForm(index){
            this.showForms[index] = !this.showForms[index]
            this.showForms = [...this.showForms]
        },
        handleCheckpointFieldDataChange(output){
            this.errs = {}
            this.removeCheckpointFieldData(output.registration._id);
            this.recordedCheckpointFieldData.push(output);
            this.needsSavingFields = true
        },
        removeCheckpointFieldData(regId){
            this.recordedCheckpointFieldData = this.recordedCheckpointFieldData.filter(data => data.registration._id != regId);
        },
        getFieldValueFromRegistration(fieldId, registration){
            if(fieldId){
                let regFields = registration.fields;
                let field = regFields.find(el => el._id == fieldId)
                if(field && field.value != undefined) return field.value;
            }
            return null
        },
        async handleDecoded(data){
            this.registrationId = data;
            this.processingQr = true
            await this.scan()
        },
        setTicks(idx, val){
            if(this.ticks[idx] == undefined) this.ticks[idx] = val
        },
        toggleSelectCheckins(ch, inc) {
            if(!inc){
                this.selectedCheckins = this.selectedCheckins.filter(el => el._id != ch._id)
            }
            else {
                this.selectedCheckins.push(ch)
            }
            
        },
        async scan() {
            if(!this.registrationId){
                return this.$notify({
                    message: "Registration id or confirmation number is required",
                    type: "danger"
                });
            }
            this.loading = true
            try {
                const res = await http.post(`/api/checkpoints/checkins-by-reg-id`, { registrationId: this.registrationId, checkpointId: this.id, eventId: this.event._id });
                this.checkins = res.data.checkins;
                this.checkins.forEach(ch => {
                    ch.attendees.forEach(at =>{
                        at.checkin = ch;
                        this.attendees.push(at)
                    })
                })
                if(this.checkins.length == 0){
                    this.$notify({
                        message: "No checkin found for this registration id or confirmation number",
                        type: "warning"
                    });
                }
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }

            this.loading = false
            this.processingQr = false;
        },
        rescan() {
            this.selectedCheckins = []
            this.checkins = []
            this.attendees = []
            this.ticks = []
            this.registrationId = ""
        },
        async printCheckins(){
            this.loading = true
            if(this.checkpoint.kioskLocalPrintOnly){
                this.selectedCheckins.forEach(ch =>{
                    this.print(ch);
                });
            }else{
                try {
                    // add print-job for selected checkins
                    const res = await http.post(`/api/print-jobs/checkpoints`, {
                        checkinIds: this.selectedCheckins.map(ch => ch._id),
                        eventId: this.event._id
                    })
                    this.$notify(res.data.message);
                } catch (error) {
                    console.log(error);
                }
            }
            this.loading = false 
            let timer = setTimeout(()=>{
                this.$router.replace(this.home);
                clearTimeout(timer)
            }, 2000);

            
        },
        async print(checkin) {
            let checkpointName = this.checkpoint.name;
            let code = checkin.code;
            let confirmationNumber = checkin.primaryRegistrant.confirmationNumber;
            let labels = []
            const res = await http.get(`/api/checkpointfields-data?eventId=${this.$route.params.eventId}&registration=${confirmationNumber}&isConfirmationNumber=true`);
            const checkpointFieldData = res.data.data;
            const printOnBadgeFields = this.checkpoint.fieldsForCheckinAndAttendeesPage.filter(f => f.printInfoOnBadge)
            
            checkin.attendees.forEach(at =>{
                let names = this.getNameFromRegistration(at).split(',')
                const regCheckpointFieldData = checkpointFieldData.find(cfd => cfd.registration == at._id)
                const regPrintOnBadgeValues = []
                printOnBadgeFields.forEach(f => {
                    let val = this.getFieldValueFromRegistration(f._id, regCheckpointFieldData)
                    if(val) regPrintOnBadgeValues.push(val)
                })
                // console.log(regPrintOnBadgeValues);
                labels.push(
                    `<?xml version="1.0" encoding="utf-8"?>
                        <DieCutLabel Version="8.0" Units="twips">
                            <PaperOrientation>Landscape</PaperOrientation>
                            <Id>ZipDisk</Id>
                            <IsOutlined>false</IsOutlined>
                            <PaperName>30370 Zip Disk</PaperName>
                            <DrawCommands>
                                <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                            </DrawCommands>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${checkpointName}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="344" Y="1527" Width="1764" Height="311.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <BarcodeObject>
                                    <Name>BARCODE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <Text>${at._id}</Text>
                                    <Type>QRCode</Type>
                                    <Size>Large</Size>
                                    <TextPosition>None</TextPosition>
                                    <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <TextEmbedding>None</TextEmbedding>
                                    <ECLevel>0</ECLevel>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                </BarcodeObject>
                                <Bounds X="2163" Y="1395" Width="1095" Height="1044" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <ShapeObject Stroke="SolidLine">
                                    <Name>SHAPE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <ShapeType>HorizontalLine</ShapeType>
                                    <LineWidth>15</LineWidth>
                                    <LineAlignment>Center</LineAlignment>
                                    <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                </ShapeObject>
                                <Bounds X="317" Y="1350" Width="2775" Height="15" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_1</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${names[1].toUpperCase()}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="24" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="195" Width="2851" Height="497.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_2</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${names[0].toUpperCase()}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="20" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="843.000000000001" Width="2805" Height="366" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_3</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${code}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="1983" Width="1798" Height="357" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_4</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${ confirmationNumber} | ${ checkin.attendees.length } ${ regPrintOnBadgeValues.length ? ' | ' + regPrintOnBadgeValues.join(' | ') : '' }</String>
                                            <Attributes>
                                                <Font Family="Century Gothic" Size="12" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="2494" Width="2835" Height="165" />
                            </ObjectInfo>
                        </DieCutLabel>
                `)
            });

            labels.push(
                `<?xml version="1.0" encoding="utf-8"?>
                        <DieCutLabel Version="8.0" Units="twips">
                            <PaperOrientation>Landscape</PaperOrientation>
                            <Id>ZipDisk</Id>
                            <IsOutlined>false</IsOutlined>
                            <PaperName>30370 Zip Disk</PaperName>
                            <DrawCommands>
                                <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                            </DrawCommands>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>CenterBlock</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${checkpointName}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="353.000000000001" Y="1593" Width="2769" Height="371.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <ShapeObject Stroke="SolidLine">
                                    <Name>SHAPE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <ShapeType>HorizontalLine</ShapeType>
                                    <LineWidth>15</LineWidth>
                                    <LineAlignment>Center</LineAlignment>
                                    <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                </ShapeObject>
                                <Bounds X="317" Y="1470" Width="2880" Height="15" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_1</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${code}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="20" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="315" Width="1447" Height="467.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_2</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Count: ${checkin.attendees.length}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="903.000000000001" Width="1398" Height="456" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_3</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Registration: ${confirmationNumber}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="11" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="347.999999999999" Y="2025" Width="2772" Height="300" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_4</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>CenterBlock</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">Retain this label for Checkout</String>
                                            <Attributes>
                                                <Font Family="Arial" Size="10" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="2446" Width="2880" Height="270" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <BarcodeObject>
                                    <Name>BARCODE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <Text>${checkin.primaryRegistrant._id}</Text>
                                    <Type>QRCode</Type>
                                    <Size>Medium</Size>
                                    <TextPosition>None</TextPosition>
                                    <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <TextEmbedding>None</TextEmbedding>
                                    <ECLevel>0</ECLevel>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                </BarcodeObject>
                                <Bounds X="1818" Y="270.000000000001" Width="1212" Height="990" />
                            </ObjectInfo>
                        </DieCutLabel>
                `)

            let done = false;
            dymo.label.framework.trace = true;
            dymo.label.framework.init(() => {
                const printers = dymo.label.framework.getPrinters();

                if (!printers.length) {
                    console.log("no supported printers found");
                    return done;
                }
                console.log("Printers: ", printers)
                try {

                    for(let labelXml of labels){
                        const label = dymo.label.framework.openLabelXml(labelXml);
                        label.print("DYMO LabelWriter 450");
                    }
                    done = true;
                } catch (error) {
                    console.log(error);
                }
            });

            return done;
        },
        getNameFromRegistration(registration){
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (lastName) name += lastName.value + ','
            if (firstName) name += firstName.value

            return name
        },
    },
    filters: {
        registrationName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName.value

            return name
        },
        formatTimestamp: (date) => moment(date).format('DD MMM YYYY HH:mm')
    },
    async mounted(){
        let params = { filters: { eventId: this.$route.params.eventId } }
        
        if(!this.fields.length) await this.$store.dispatch('getAll', { path: 'fields', params })
        if(!this.checkpoints.length) await this.$store.dispatch('getAll', { path: 'checkpoints', params });

        this.checkpoint = this.checkpoints.find(el => el._id == this.id);

        if(this.$route.query.regNoOrId){
            this.registrationId = this.$route.query.regNoOrId
            this.scan()
        }

        try {
            const res = await http.get(`/api/checkpointfields?eventId=${this.$route.params.eventId}`);
            this.checkpointFields = res.data.fields;
        } catch (error) {
            this.$store.dispatch('handleErrors', error);
        }

        if(!this.checkpoint.kioskAllowBadgePrintingForExternal){
            this.$router.back()
        }

        this.home = `/evt/${this.event._id}/`+ 'kiosk' +`/${this.checkpoint._id}`
    }
}


</script>

<style scoped>

/* Hide the default checkbox */
.checkbox-container input {
    display: none;
}
.checkbox-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Create a custom checkbox */
.checkbox-container .checkmark {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #ffffff;
    position: relative;
    cursor: pointer;
    border: 0.5px solid rgb(156, 156, 156);
}

/* Hide the SVG checkmark by default */
.checkbox-container .checkmark-svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    stroke-width: 5;
    stroke: #ffffff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 71;
    stroke-dashoffset: 71;
    transition: all 0.3s ease-out;
    opacity: 0;
}

/* Show the SVG checkmark when the checkbox is checked */
.checkbox-container input:checked ~ .checkmark .checkmark-svg {
    stroke-dashoffset: 0;
    opacity: 1;
}
.checkbox-container input:checked ~ .checkmark {
    background: #409EFF;
}
.checkbox-container input:checked ~ .checkmark[disabled] {
    background: #d3d3d3;
    cursor: not-allowed;
}

.idinput{
    display: flex;
    align-items: center;
    gap: 5px;
    max-width: 500px;
    margin: 0 auto;
}

.badge-scanner{
    max-width: 500px;
    margin: 0 auto;
}

.scan-badge-btn{
    width: 100%;
    min-width: max-content;
}

@media screen and (max-width: 500px) {
    .idinput{
        flex-direction: column;
    }
    .proceed-btn{
        width: 100%;
    }
}

</style>